const config = {}
    // if (process.env.NODE_ENV === 'development') {
    //     // 开发环境
    //     config.domain = '192.168.1.91:8070'
    //         // config.domain = 'api.spr-atm.com'
    // }
    // else if (process.env.NODE_ENV === 'production') {
    //   // 生产环境
    //   config.domain = '192.168.1.91:8070'
    //   // config.domain = 'api.spr-atm.com'
    // } else {
    //   config.domain = '192.168.1.91:8070'
    // }
config.domain = process.env.VUE_APP_WEB_API_DOMAIN
module.exports = config